import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.1875 3.5C3.1875 3.18934 3.43934 2.9375 3.75 2.9375H13.875C14.1857 2.9375 14.4375 3.18934 14.4375 3.5V13.625C14.4375 14.557 13.682 15.3125 12.75 15.3125H4.875C3.94302 15.3125 3.1875 14.557 3.1875 13.625V3.5ZM4.3125 4.0625V13.625C4.3125 13.9357 4.56434 14.1875 4.875 14.1875H12.75C13.0607 14.1875 13.3125 13.9357 13.3125 13.625V4.0625H4.3125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.9375 3.5C0.9375 3.18934 1.18934 2.9375 1.5 2.9375H16.125C16.4357 2.9375 16.6875 3.18934 16.6875 3.5C16.6875 3.81066 16.4357 4.0625 16.125 4.0625H1.5C1.18934 4.0625 0.9375 3.81066 0.9375 3.5ZM7.125 6.3125C7.43566 6.3125 7.6875 6.56434 7.6875 6.875V11.375C7.6875 11.6857 7.43566 11.9375 7.125 11.9375C6.81434 11.9375 6.5625 11.6857 6.5625 11.375V6.875C6.5625 6.56434 6.81434 6.3125 7.125 6.3125ZM10.5 6.3125C10.8107 6.3125 11.0625 6.56434 11.0625 6.875V11.375C11.0625 11.6857 10.8107 11.9375 10.5 11.9375C10.1893 11.9375 9.9375 11.6857 9.9375 11.375V6.875C9.9375 6.56434 10.1893 6.3125 10.5 6.3125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.4375 2.375C5.4375 1.44302 6.19302 0.6875 7.125 0.6875H10.5C11.432 0.6875 12.1875 1.44302 12.1875 2.375V3.5C12.1875 3.81066 11.9357 4.0625 11.625 4.0625H6C5.68934 4.0625 5.4375 3.81066 5.4375 3.5V2.375ZM7.125 1.8125C6.81434 1.8125 6.5625 2.06434 6.5625 2.375V2.9375H11.0625V2.375C11.0625 2.06434 10.8107 1.8125 10.5 1.8125H7.125Z",
			fill: "currentColor"
		})
	]
});
export { SvgTrash as ReactComponent };
